"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _dialogCloseMixin = require("../dialogCloseMixin");
/** @class DialogMixin */
/**
 * Adds core styling to `Dialog` based components.
 *
 * @example
 * import { DialogMixin } from "@zillow/constellation";
 *
 * const Component = styled.div`
 *     ${DialogMixin}
 * `;
 *
 * <Component>My dialog component</Component>
 *
 * @method
 * @param props {object}
 * @param props.theme {object} The styled-components theme.
 * @return {CSSObject}
 */
var DialogMixin = function DialogMixin(props) {
  return (0, _styledToken.default)({
    backgroundColor: 'Dialog.backgroundColor',
    boxShadow: 'Dialog.boxShadow',
    borderRadius: 'Dialog.borderRadius'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      boxShadow = _ref.boxShadow,
      borderRadius = _ref.borderRadius;
    return (0, _styledComponents.css)(["box-sizing:border-box;background-color:", ";box-shadow:", ";outline:none;border-radius:", "px;", ""], backgroundColor, boxShadow, borderRadius, (0, _dialogCloseMixin.dialogCloseMixin)(props));
  })(props);
};
exports.DialogMixin = DialogMixin;